import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Megaphone, Plus } from "lucide-react";
import ManageHeader from "@components/ManageHeader";
import DateInput from "@components/forms/DateInput";
import { date_now, lastDayCurrentMonth } from "@global/actions";
import ListingPromos from "./components/ListingPromos";
import { useModal } from "@components/ModalContext";
import FormPromotion from "./forms/FormPromotion";
import { loadPromos } from "./Actions";
const Promotions = (props) => {
  const { t } = useTranslation();
  const id = useParams().id;
  const service = useParams().service;
  const [promos, setPromos] = useState([]);
  const { openModal, setSize, setTitle, closeModal } = useModal();
  const [dateFrom, setDateFrom] = useState(date_now());
  const [dateTo, setDateTo] = useState(lastDayCurrentMonth());
  const onChangeDate = (from, to) => {
    setDateFrom(from);
    setDateTo(to);
  };
  const loadData = async () => {
    setPromos(await loadPromos(id, dateFrom, dateTo));
  };
  const addPromotion = () => {
    setSize("md");
    setTitle(t("new_promotion"));
    openModal(
      <FormPromotion
        id={id}
        mode={props.mode}
        t={t}
        service={service}
        loadData={loadData}
      
      />
    );
  };

  const editPromotion = (promo) => {
    setSize("md");
    setTitle(t("update promotion"));
    openModal(
      <FormPromotion
        id={id}
        mode={props.mode}
        t={t}
        service={service}
        loadData={loadData}
        promo={promo}
      />
    );
  };
  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <ManageHeader
        title={t("promotion")}
        content={t("promotions_caption")}
        icon={<Megaphone size={25} strokeWidth={1.5} />}
      />
      <div className="row my-3">
        <div className="col-md-3 ">
          <DateInput
            leftLabel={t("from")}
            rightLabel={t("to")}
            onDateChange={onChangeDate}
            dateFrom={dateFrom}
            dateTo={dateTo}
          />
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button
            appearance="primary"
            className="px-5 pt-2 pb-3  btn-blue rounded-2"
            onClick={() => loadData(0)}
          >
            {t("search")}
          </button>
        </div>
        <div className="col-md-7  text-right d-flex align-items-end">
          <button
            appearance="primary"
            className="p-3 btn-blue rounded-2 me-3"
            onClick={() => addPromotion()}
          >
            <Plus size={25} strokeWidth={1.2} /> {t("add_promotion")}
          </button>
        </div>
      </div>

      <ListingPromos
        t={t}
        mode={props.profile.mode}
        promos={promos}
        productId={id}
        setPromos={setPromos}
        provider={props.profile.provider}
        service={service}
        loadData={loadData}
        editPromotion={editPromotion}
      />
    </>
  );
};

export default Promotions;
